
import React from 'react'
import {Get, wrapResponse} from './../../../requst'

require ('./partners.scss')



export default class Partners extends React.Component{
    static async getInitialProps(ctx){
        const data = await wrapResponse(Get({url:'base/partner'}))
        return {data}
    }
    
    constructor(props, context) {
        super(props, context)
        this.state = {
            
        }
       
    }

    renderPartners(){
        return this.props.data.map((item,index)=>(
                <li key={index} style={{overflow:'hidden'}}><img src= {item.photo} style={{width:'100%'}} alt=""/></li>
            ))
    }
    render(){
        return(
            <div className = "PartnersContainer">
                <div className = "PartnersTitle">
                    <p>合作伙伴</p>
                    <p>Cooperative Partner</p>
                    <img src = { require ( '../../../assets/common/images/biaotizhuangshi.png' ) } alt=""/>
                </div>
                <ul className = "PartnersContent">
                    {this.props.data?this.renderPartners():null}
                </ul>
                <img className = "Square" src = { require ( '../../../assets/common/images/hezuohuoban-zhuangshi.png' ) } alt=""/>
            </div>
        )
    }
}